// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_content__xTAog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgb(117, 83, 240);
  z-index: 9999;
  overflow-y: auto;
  overflow-x: hidden;
}

.style_banner__jgd-3 {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  max-width: 380px;
  margin: 0 auto;
}
.style_banner__title__4pQEr {
  margin: 10px 0;
  font-weight: 500;
  font-size: 1.6rem;
  color: rgb(247, 246, 255);
  position: relative;
  z-index: 9;
}
.style_banner__subtitle__DkKz7 {
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 3rem;
  color: rgb(247, 246, 255);
  position: relative;
  z-index: 9;
}
.style_banner__sunshine__utvSQ {
  position: absolute;
  top: -21%;
  left: 42%;
  transform: translate(-50%, -50%);
  width: 100vw;
  z-index: 0;
  max-width: 380px;
}
.style_banner__sunshine__utvSQ img {
  animation: style_rotate__O3eUs 20s linear infinite;
}
.style_banner__images__v78kB {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
}
.style_banner__images__v78kB img {
  position: relative;
  z-index: 9;
}
.style_banner__timer__FNkXP {
  position: relative;
  padding: 6px 12px;
  line-height: 20px;
  border-radius: 20px;
  background: rgb(85, 46, 224);
  color: rgb(255, 255, 255);
  font-size: 1.6rem;
  font-weight: 600;
  display: flex;
  justify-content: center;
  gap: 4px;
  min-width: 220px;
}

.style_leaderboard__vTRBP {
  margin-top: 80px;
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(3, 108px);
  gap: 15px;
  white-space: nowrap;
  height: auto;
  justify-content: center;
  position: relative;
}

.style_item__zEAUZ {
  position: relative;
  z-index: 4;
  width: 108px;
  display: flex;
  clip-path: polygon(0 0, 100% -180%, 100% 85%, 50% 100%, 0 85%);
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 50px;
  height: 189px;
}
.style_item__prize__Vz5QT {
  position: absolute;
  top: 10px;
  right: -30px;
}
.style_item__title__NBh4Q {
  color: rgb(255, 255, 255);
  font-size: 24px;
  font-weight: 800;
  line-height: 29.26px;
  text-align: center;
  margin-bottom: 9px;
}
.style_item__logo__FcU61 {
  width: 50px;
  height: 50px;
}
.style_item__name__c-qBK {
  margin-top: 5px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 4px;
}
.style_item__name__prefix__7xBS4 {
  color: rgba(247, 246, 255, 0.5);
  font-size: 10px;
  font-weight: 500;
  line-height: 10px;
  text-align: center;
}
.style_item__name__content__NS7h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 12px;
  text-align: center;
  color: rgb(255, 255, 255);
}
.style_item__trophy__o\\+xzV {
  width: 90px;
  height: 90px;
  position: absolute;
  top: -75px;
}
.style_item__trophy__o\\+xzV img {
  width: 100%;
  height: 100%;
}

.style_item__bottom__angle__xIyDT {
  position: absolute;
  z-index: 0;
  width: 101px;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  clip-path: polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%);
}

.style_empty__rF82- {
  text-align: center;
  padding: 45px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.style_empty__title__BGI5y {
  font-size: 2rem;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: rgb(255, 255, 255);
}
.style_empty__description__3WWEx {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: rgb(255, 255, 255);
  max-width: 315px;
}

.style_action__wrapper__uASAQ {
  display: flex;
  width: 100vw;
  justify-content: center;
}

.style_action__0fc5i {
  width: 80vw;
  position: absolute;
  top: 90%;
}

.style_reward__4lJ3S {
  margin-top: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 360px;
}
@media screen and (max-height: 600px) {
  .style_reward__4lJ3S {
    margin-top: 5px;
    gap: 4px;
  }
}
.style_reward__amount__E3mtx {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  width: 100%;
  border: 2px solid rgb(255, 255, 255);
  border-radius: 16px;
}
.style_reward__amount__title__JvdX7 {
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: rgb(255, 255, 255);
}
@media screen and (max-height: 600px) {
  .style_reward__amount__title__JvdX7 {
    font-size: 1.6rem;
  }
}
.style_reward__amount__content__B3kpV {
  display: flex;
  justify-content: center;
  gap: 4px;
  font-size: 28px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  color: rgb(255, 255, 255);
}
@media screen and (max-height: 600px) {
  .style_reward__amount__content__B3kpV {
    font-size: 2rem;
  }
}
.style_reward__amount__content__B3kpV img {
  width: 22px;
  height: 22px;
}
.style_reward__description__ovjYe {
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: rgb(213, 212, 220);
  max-width: 315px;
}

@keyframes style_rotate__O3eUs {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/cw-reward/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,6BCRK;EDSL,aAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AADF;AAGE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AADJ;AAIE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAFJ;AAKE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAHJ;AAII;EACE,kDAAA;AAFN;AAME;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;AAJJ;AAMI;EACE,kBAAA;EACA,UAAA;AAJN;AAQE;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;EACA,yBCpEI;EDqEJ,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AANJ;;AAUA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,8DAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;AAPF;AASE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;AAPJ;AAUE;EACE,yBC9GI;ED+GJ,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AARJ;AAWE;EACE,WAAA;EACA,YAAA;AATJ;AAYE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AAVJ;AAYI;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAVN;AAaI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBC/IE;ADoIR;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAbJ;AAeI;EACE,WAAA;EACA,YAAA;AAbN;;AAkBA;EACE,kBAAA;EACA,UAAA;EAEA,YAAA;EACA,oCAAA;EACA,wCAAA;EACA,0DAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAhBF;AAkBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBCtLI;ADsKR;AAmBE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBC9LI;ED+LJ,gBAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAlBF;AAmBE;EAPF;IAQI,eAAA;IACA,QAAA;EAhBF;AACF;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBC3OE;AD2NR;AAiBM;EANF;IAOI,iBAAA;EAdN;AACF;AAiBI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBC1PE;AD0OR;AAiBM;EAVF;IAWI,eAAA;EAdN;AACF;AAgBM;EACE,WAAA;EACA,YAAA;AAdR;AAmBE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAjBJ;;AAqBA;EACE;IACE,uBAAA;EAlBF;EAoBA;IACE,yBAAA;EAlBF;AACF","sourcesContent":["@import 'public/assets/colors';\n\n.content {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: $main;\n  z-index: 9999;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.banner {\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  max-width: 380px;\n  margin: 0 auto;\n\n  &__title {\n    margin: 10px 0;\n    font-weight: 500;\n    font-size: 1.6rem;\n    color: rgba(247, 246, 255, 1);\n    position: relative;\n    z-index: 9;\n  }\n\n  &__subtitle {\n    margin-bottom: 10px;\n    font-weight: 700;\n    font-size: 3rem;\n    color: rgba(247, 246, 255, 1);\n    position: relative;\n    z-index: 9;\n  }\n\n  &__sunshine {\n    position: absolute;\n    top: -21%;\n    left: 42%;\n    transform: translate(-50%, -50%);\n    width: 100vw;\n    z-index: 0;\n    max-width: 380px;\n    img {\n      animation: rotate 20s linear infinite;\n    }\n  }\n\n  &__images {\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n\n    img {\n      position: relative;\n      z-index: 9;\n    }\n  }\n\n  &__timer {\n    position: relative;\n    padding: 6px 12px;\n    line-height: 20px;\n    border-radius: 20px;\n    background: rgba(85, 46, 224, 1);\n    color: $white;\n    font-size: 1.6rem;\n    font-weight: 600;\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n    min-width: 220px;\n  }\n}\n\n.leaderboard {\n  margin-top: 80px;\n  width: 100%;\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-columns: repeat(3, 108px);\n  gap: 15px;\n  white-space: nowrap;\n  height: auto;\n  justify-content: center;\n  position: relative;\n}\n\n.item {\n  position: relative;\n  z-index: 4;\n  width: 108px;\n  display: flex;\n  clip-path: polygon(0 0, 100% -180%, 100% 85%, 50% 100%, 0 85%);\n  flex-direction: column;\n  align-items: center;\n  padding-top: 10px;\n  padding-bottom: 50px;\n  height: 189px;\n\n  &__prize {\n    position: absolute;\n    top: 10px;\n    right: -30px;\n  }\n\n  &__title {\n    color: $white;\n    font-size: 24px;\n    font-weight: 800;\n    line-height: 29.26px;\n    text-align: center;\n    margin-bottom: 9px;\n  }\n\n  &__logo {\n    width: 50px;\n    height: 50px;\n  }\n\n  &__name {\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 4px;\n\n    &__prefix {\n      color: rgba(247, 246, 255, 0.5);\n      font-size: 10px;\n      font-weight: 500;\n      line-height: 10px;\n      text-align: center;\n    }\n\n    &__content {\n      font-size: 16px;\n      font-weight: 700;\n      line-height: 12px;\n      text-align: center;\n      color: $white;\n    }\n  }\n\n  &__trophy {\n    width: 90px;\n    height: 90px;\n    position: absolute;\n    top: -75px;\n\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n\n.item__bottom__angle {\n  position: absolute;\n  z-index: 0;\n\n  width: 101px;\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  clip-path: polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%);\n}\n\n.empty {\n  text-align: center;\n  padding: 45px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  &__title {\n    font-size: 2rem;\n    font-weight: 700;\n    line-height: 20px;\n    text-align: center;\n    color: $white;\n  }\n\n  &__description {\n    font-size: 1.4rem;\n    font-weight: 500;\n    line-height: 20px;\n    text-align: center;\n    color: $white;\n    max-width: 315px;\n  }\n}\n\n.action__wrapper {\n  display: flex;\n  width: 100vw;\n  justify-content: center;\n}\n\n.action {\n  width: 80vw;\n  position: absolute;\n  top: 90%;\n}\n\n.reward {\n  margin-top: 45px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  width: 360px;\n  @media screen and (max-height: 600px) {\n    margin-top: 5px;\n    gap: 4px;\n  }\n\n  &__amount {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 8px;\n    padding: 16px;\n    width: 100%;\n    border: 2px solid rgba(255, 255, 255, 1);\n    border-radius: 16px;\n\n    &__title {\n      font-size: 20px;\n      font-weight: 700;\n      line-height: 20px;\n      text-align: center;\n      color: $white;\n      @media screen and (max-height: 600px) {\n        font-size: 1.6rem;\n      }\n    }\n\n    &__content {\n      display: flex;\n      justify-content: center;\n      gap: 4px;\n\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 28px;\n      text-align: left;\n      color: $white;\n      @media screen and (max-height: 600px) {\n        font-size: 2rem;\n      }\n\n      img {\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n\n  &__description {\n    font-size: 1.2rem;\n    font-weight: 500;\n    line-height: 20px;\n    text-align: center;\n    color: rgba(213, 212, 220, 1);\n    max-width: 315px;\n  }\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `style_content__xTAog`,
	"banner": `style_banner__jgd-3`,
	"banner__title": `style_banner__title__4pQEr`,
	"banner__subtitle": `style_banner__subtitle__DkKz7`,
	"banner__sunshine": `style_banner__sunshine__utvSQ`,
	"rotate": `style_rotate__O3eUs`,
	"banner__images": `style_banner__images__v78kB`,
	"banner__timer": `style_banner__timer__FNkXP`,
	"leaderboard": `style_leaderboard__vTRBP`,
	"item": `style_item__zEAUZ`,
	"item__prize": `style_item__prize__Vz5QT`,
	"item__title": `style_item__title__NBh4Q`,
	"item__logo": `style_item__logo__FcU61`,
	"item__name": `style_item__name__c-qBK`,
	"item__name__prefix": `style_item__name__prefix__7xBS4`,
	"item__name__content": `style_item__name__content__NS7h3`,
	"item__trophy": `style_item__trophy__o+xzV`,
	"item__bottom__angle": `style_item__bottom__angle__xIyDT`,
	"empty": `style_empty__rF82-`,
	"empty__title": `style_empty__title__BGI5y`,
	"empty__description": `style_empty__description__3WWEx`,
	"action__wrapper": `style_action__wrapper__uASAQ`,
	"action": `style_action__0fc5i`,
	"reward": `style_reward__4lJ3S`,
	"reward__amount": `style_reward__amount__E3mtx`,
	"reward__amount__title": `style_reward__amount__title__JvdX7`,
	"reward__amount__content": `style_reward__amount__content__B3kpV`,
	"reward__description": `style_reward__description__ovjYe`
};
export default ___CSS_LOADER_EXPORT___;
